import React from 'react';
import './Navbar.css'
import { Link } from 'react-router-dom';
import {FaBars , FaTimes } from 'react-icons/fa'
import { useState } from 'react';

const Navbar = () => {
    const [click, setclick] = useState(false);
    const handleClick = ()=> setclick(!click)

    const [color, setColor] = useState(false);
    
    const colorChanger = () => {
        if (window.scrollY >= 100) {
            setColor(true)
        } else {
            setColor(false)
        }

    }
    window.addEventListener("scroll" , colorChanger)


    return (
        <div className={color ? " Header Header-bg " : ' Header ' }>
        <Link to='/'><h1>GLX Travel</h1></Link> 
        <ul className={click?'active' : 'ul'}>
            <li>
                <Link to='/' >Home</Link>
            </li>
            <li>
                <Link to='/Pricing'>Pricing</Link>
            </li>
            <li>
                <Link to='/Training'>Training</Link>
            </li>
            <li>
                <Link to='/Contact'>Contact</Link>
            </li>
        </ul>
            <div className='hamburger' onClick={handleClick}>
                {click ? <FaTimes size={30} style={{color:'#fff'}} /> : <FaBars size={30} style={{color:'#fff'}} /> }
                
            </div>
        </div>
    );
}

export default Navbar;
